import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OperatorTrafficPage } from "@/features/operator/TrafficPage";

export const Route = createFileRoute("/app/operator/traffic")({
  validateSearch: z.object({
    window: z.enum(["24h", "7d", "30d"]).optional().catch(undefined),
    dim: z.enum(["tenant", "user", "node"]).optional().catch(undefined),
    tenant: z.string().optional(),
    user: z.string().optional(),
    node: z.string().optional(),
  }),
  component: OperatorTrafficPage,
});
